//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('currencyTypes', {
//        templateUrl: 'views/components/views/currencyTypes/currencyTypes.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'utilityService', 'currencyTypesService', function ($stateParams, utilityService, currencyTypesService) {
//            const vm = this;
//            let valutaId = $stateParams.valuta_id;
            
//            vm.model = {
//                setting: {},
//    			itemsListCurrencyTypes: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await currencyTypesService.getCurrencyType({ valuta_id: valutaId }))[0];

//                return loadCurrencyTypes();
//            }

//            async function loadCurrencyTypes() {
//                if (utilityService.validateParmsValue(vm.model.setting.valuta_id) !== true) return;

//                return vm.model.itemsListCurrencyTypes = await currencyTypesService.listCurrencyTypes({ valuta_id: vm.model.setting.valuta_id });
//            }

//            vm.$onInit = function () {
//                loadSetting();
//            }
//        }]
//    });
//})();
